import { ParsedExportBaseSchema } from './parsedBase.js';
import { z } from 'zod';
export const ParsedNoteExportSchema = ParsedExportBaseSchema.merge(z.object({
    note: z.string(),
    type: z.string(),
    userName: z.string(),
}));
